import {useState,useId} from 'react';
import {hasOrbitalPosition,positionExplanation} from '../utils/orbitalCamera.js';
export default function ObjectActions({sat,tracked,onFollow,onUntrack}) {
  const [message,setMessage]=useState('');
  const reasonId=useId(),ready=hasOrbitalPosition(sat);
  async function share() {
    const url=`${window.location.origin}${window.location.pathname}?norad=${sat.norad_id}`;
    try {
      if(navigator.share){await navigator.share({title:sat.name||`NORAD ${sat.norad_id}`,url});setMessage('Shared');}
      else if(navigator.clipboard?.writeText){await navigator.clipboard.writeText(url);setMessage('Link copied');}
      else setMessage('Copy this link: '+url);
    }catch(error){if(error.name!=='AbortError')setMessage('Could not share. Copy this link: '+url);}
  }
  return <div className="og-object-actions"><div><button disabled={!tracked&&!ready} aria-describedby={!ready?reasonId:undefined} title={!ready?positionExplanation(sat):undefined} aria-pressed={!!tracked} onClick={()=>tracked?onUntrack?.():ready&&onFollow?.(sat)}>{tracked?'Unfollow':'Follow'}</button><button onClick={share}>Share</button></div>{!ready&&<p id={reasonId} role="status">{positionExplanation(sat)}</p>}{message&&<p role="status">{message}</p>}</div>;
}
